module.exports = __webpack_public_path__ + "static/media/15c-05_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.58994267.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15c/15c-05_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg
// module id = 167
// module chunks = 0